import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { PurchaseOrderRetryInput, PurchaseOrderRetryPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = PurchaseOrderRetryInput;
type TData = PurchaseOrderRetryPayload;

export const usePaymentRetry = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation purchaseOrderRetry($input: PurchaseOrderRetryInput!) {
      purchaseOrderRetry(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
